import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "c-lnb pc" }
const _hoisted_2 = { class: "c-lnb__list" }
const _hoisted_3 = { class: "c-lnb__tooltip" }
const _hoisted_4 = { class: "c-lnb__list" }
const _hoisted_5 = { class: "c-lnb__item-wrap" }

import { computed, onMounted, ref, watch, inject } from 'vue';
import { useRoute } from 'vue-router';
import { roleStore } from '@/stores/role';

import { projectStore } from '@/stores/project';

import { $t } from '@/plugins/translation';


export default /*@__PURE__*/_defineComponent({
  __name: 'LeftMenu',
  setup(__props) {

const $ga = inject('$ga') as any;
const roleModule = roleStore();
const projectModule = projectStore();
const selectedProjectIdx = computed(() => projectModule.selectedProjectId || 0);

// const isDev = computed(
//   () => process.env.VUE_APP_MODE === 'DEV' || process.env.VUE_APP_MODE === 'LOCAL',
// );

const routes = computed(() => [
  { path: '/', iconClass: 'c-lnb__icon', tooltip: $t('common', 'home') },
  // {
  //   path: '/recruitment',
  //   iconClass: 'c-lnb__icon c-lnb__icon--union',
  //   tooltip: $t('component.header', 'recruitment'),
  //   showCondition: isDev.value,
  // },
  {
    path: `/dashboard/${selectedProjectIdx.value}`,
    iconClass: 'c-lnb__icon c-lnb__icon--dashboard',
    tooltip: $t('component.header', 'dashboard'),
  },
  // {
  //   path: `/pilot/${selectedProjectIdx.value}`,
  //   iconClass: 'c-lnb__icon c-lnb__icon--dashboard',
  //   tooltip: $t('component.header', 'pilot'),
  // },
  {
    path: `/epic/${selectedProjectIdx.value}`,
    iconClass: 'c-lnb__icon c-lnb__icon--epic',
    tooltip: $t('common', 'epic'),
  },
  {
    path: `/timeline/${selectedProjectIdx.value}`,
    iconClass: 'c-lnb__icon c-lnb__icon--calendar',
    tooltip: $t('component.header', 'timeline'),
  },
  {
    path: `/request/${selectedProjectIdx.value}`,
    iconClass: 'c-lnb__icon c-lnb__icon--request',
    tooltip: $t('common', 'request'),
  },
  {
    path: calculateRoute.value,
    iconClass: 'c-lnb__icon c-lnb__icon--point',
    tooltip: $t('component.header', 'settlement'),
  },
  {
    path: `/doclist/${selectedProjectIdx.value}`,
    iconClass: 'c-lnb__icon c-lnb__icon--docs',
    tooltip: $t('common', 'doclist'),
    // showCondition: isDev.value,
  },
  {
    path: `/setting`,
    iconClass: 'c-lnb__icon c-lnb__icon--setting',
    tooltip: $t('common', 'setting'),
  },
]);
const calculateRoute = computed(() => {
  if (roleModule.isClient) {
    return `/calculate/client/${selectedProjectIdx.value}`;
  } else {
    return `/calculate/expert/${selectedProjectIdx.value}`;
  }
});

// check device
const isMobile = ref(false);
const showMenu = ref(false);

const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 767;
};
const checkShowMenu = () => {
  showMenu.value = !showMenu.value;
};

const menuKey = ref(0);
const route = useRoute();

const trackNavigation = (routeItem: { path: string; tooltip: string }) => {
  try {
    $ga?.trackEvent?.('navigation_click', {
      label: routeItem.tooltip,
      path: routeItem.path,
      position: isMobile.value ? 'mobile_left_menu' : 'desktop_left_menu',
    });
  } catch (e) {
    // no-op
  }
};

watch(
  () => route.fullPath,
  () => {
    showMenu.value = false;
    menuKey.value += 1;
    setTimeout(() => {
      showMenu.value = false;
    }, 0);
  },
);

onMounted(() => {
  checkIsMobile();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.value, (route, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (route?.showCondition ?? true)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: route.path,
                  "active-class": "bg-[#007f70]",
                  class: "c-lnb__item",
                  onClick: ($event: any) => (trackNavigation(route))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(route.iconClass)
                    }, null, 2),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(route.tooltip), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "onClick"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ], 512), [
      [_vShow, !isMobile.value]
    ]),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (checkShowMenu()))
    }),
    _withDirectives((_openBlock(), _createElementBlock("nav", {
      class: _normalizeClass(["c-lnb mo", { on: showMenu.value }]),
      key: menuKey.value
    }, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.value, (route, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (route?.showCondition ?? true)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: route.path,
                  class: "c-lnb__item",
                  onClick: ($event: any) => (trackNavigation(route))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("i", {
                        class: _normalizeClass(route.iconClass)
                      }, null, 2),
                      _createElementVNode("h2", null, _toDisplayString(route.tooltip), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to", "onClick"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ], 2)), [
      [_vShow, isMobile.value]
    ])
  ], 64))
}
}

})